import { CustomerModel } from 'api-hooks/customer';
import { AuthorizationRules } from 'common/constants';
import notification from 'components/common/notification';
import { PopoverMenuType } from 'components/popover';
import { useAuthorization } from 'hooks/use-authorization';
import useDrawer from 'hooks/use-drawer';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import ListGuestPanel from '../components/list-guest/list-guest-panel';

export default function useCustomerGuestListAction(customer?: CustomerModel) {
  const drawer = useDrawer();
  const id = customer?.id;
  const { can } = useAuthorization();
  const { t } = useTranslation();

  const onViewListGuest = React.useCallback(
    (currentId?: string) => {
      const _id = currentId ?? id;
      const message = {
        id: _id || 'undefined',
        message: 'Invalid Customer View Guest List Action (FE)',
      };

      if (!_id) {
        notification.error({
          message: JSON.stringify(message),
        });
        return;
      }
      drawer.showCustom({
        desktopDrawerWidthPercentage: 45,
        render: (onClose) => (
          <ListGuestPanel customerId={_id} onClose={onClose} />
        ),
      });
    },
    [drawer, id],
  );

  const customerGuestListPermission = can(
    AuthorizationRules.CustomersGetGuests,
  );

  const customerGuestListAction: PopoverMenuType = {
    key: `customer-guest-list-${id}`,
    onClick: onViewListGuest,
    label: t('customer:view_guest'),
    isAllowed: customerGuestListPermission,
  };

  return {
    onViewListGuest,
    customerGuestListPermission,
    customerGuestListAction,
  };
}
